<form class="support-modal__form" [formGroup]="form" (ngSubmit)="submit()">
  <div class="form-item">
    <p-floatlabel variant="in">
      <input pInputText id="support-name" formControlName="name" />
      <label for="support-name">{{ 'general.name' | translate }}</label>
    </p-floatlabel>

    <ng-container
      *ngTemplateOutlet="
        errorTpl;
        context: { $implicit: form.controls.name, label: 'general.name', max: nameMaxLength }
      "
    ></ng-container>
  </div>

  <div class="form-item">
    <p-floatlabel variant="in">
      <input pInputText id="support-email" type="email" formControlName="email" />
      <label for="support-email">{{ 'general.email' | translate }}</label>
    </p-floatlabel>

    <ng-container
      *ngTemplateOutlet="
        errorTpl;
        context: { $implicit: form.controls.email, label: 'general.email', max: emailMaxLength }
      "
    ></ng-container>
  </div>

  <div class="form-item">
    <p-floatlabel variant="in">
      <input pInputText id="support-subject" formControlName="subject" />
      <label for="support-subject">{{ 'general.subject' | translate }}</label>
    </p-floatlabel>

    <ng-container
      *ngTemplateOutlet="
        errorTpl;
        context: { $implicit: form.controls.subject, label: 'general.subject', max: subjectMaxLength }
      "
    ></ng-container>
  </div>

  <div class="form-item">
    <p-floatlabel variant="in">
      <textarea pTextarea id="support-description" formControlName="description" rows="6"></textarea>
      <label for="support-description">{{ 'general.description' | translate }}</label>
    </p-floatlabel>

    <ng-container
      *ngTemplateOutlet="
        errorTpl;
        context: {
          $implicit: form.controls.description,
          label: 'general.description',
          max: descriptionMaxLength,
        }
      "
    ></ng-container>
  </div>

  <div class="form-item support-modal__attachments">
    <span class="support-modal__attachments-label">
      {{ 'general.attachments' | translate }} ({{ 'general.optional' | translate }})
    </span>

    <label class="support-modal__upload-button" for="support-attachments">
      <i class="pi pi-upload" aria-hidden="true"></i>
      {{ 'general.uploadFiles' | translate }}
    </label>
    <input
      id="support-attachments"
      class="support-modal__file-input"
      type="file"
      accept=".pdf,.png,.jpg,.jpeg,application/pdf,image/png,image/jpeg"
      multiple
      (change)="onAttachmentsSelected($event)"
    />

    <div *ngIf="selectedAttachments.length > 0" class="support-modal__file-list">
      <div *ngFor="let attachment of selectedAttachments; let index = index" class="support-modal__file">
        <span class="support-modal__file-name">{{ attachment.name }}</span>
        <button
          class="support-modal__remove-file"
          type="button"
          [attr.aria-label]="'general.remove' | translate"
          (click)="removeAttachment(index)"
        >
          <i class="pi pi-times" aria-hidden="true"></i>
        </button>
      </div>
    </div>

    <p-message *ngIf="hasAttachmentTypeError" severity="error" variant="simple" size="small">
      {{ 'messages.invalidFileFormat' | translate: { fileTypes: acceptedAttachmentTypesLabel } }}
    </p-message>

    <p-message *ngIf="hasAttachmentFileSizeError" severity="error" variant="simple" size="small">
      {{ 'messages.oneOrMoreOfTheseFilesIsTooLarge' | translate: { size: maxAttachmentSizeLabel } }}
    </p-message>

    <p-message *ngIf="hasAttachmentCountError" severity="error" variant="simple" size="small">
      {{ 'messages.supportAttachmentsCountExceeded' | translate: { count: maxAttachmentCount } }}
    </p-message>

    <p-message *ngIf="hasAttachmentTotalSizeError" severity="error" variant="simple" size="small">
      {{ 'messages.supportAttachmentsTotalSizeExceeded' | translate: { size: maxTotalAttachmentSizeLabel } }}
    </p-message>
  </div>

  <div class="support-modal__footer">
    <p-button
      type="button"
      severity="secondary"
      [outlined]="true"
      [disabled]="progressbar$ | async"
      [label]="'general.cancel' | translate"
      (onClick)="cancel()"
    />

    <p-button
      type="submit"
      severity="primary"
      [outlined]="true"
      [disabled]="isSubmitDisabled || (progressbar$ | async)"
      [loading]="progressbar$ | async"
      [label]="'general.submit' | translate"
    />
  </div>
</form>

<ng-template #errorTpl let-control let-label="label" let-max="max">
  <p-message
    *ngIf="control.hasError('required') && (control.dirty || hasSubmitAttempted)"
    severity="error"
    variant="simple"
    size="small"
  >
    {{ label | translate }} {{ 'messages.fieldIsRequired' | translate }}
  </p-message>

  <p-message
    *ngIf="control.hasError('whitespace') && (control.dirty || hasSubmitAttempted)"
    severity="error"
    variant="simple"
    size="small"
  >
    {{ label | translate }} {{ 'messages.fieldIsRequired' | translate }}
  </p-message>

  <p-message
    *ngIf="control.hasError('email') && (control.dirty || hasSubmitAttempted)"
    severity="error"
    variant="simple"
    size="small"
  >
    {{ 'messages.emailShouldBeValid' | translate }}
  </p-message>

  <p-message
    *ngIf="control.hasError('maxlength') && (control.dirty || hasSubmitAttempted)"
    severity="error"
    variant="simple"
    size="small"
  >
    {{ label | translate }} {{ 'messages.fieldShouldBeMaximum' | translate: { number: max } }}
  </p-message>
</ng-template>
